import { render, staticRenderFns } from "./OperaProjectWindow.vue?vue&type=template&id=23bad03c&scoped=true&"
import script from "./OperaProjectWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectWindow.vue?vue&type=style&index=0&id=23bad03c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bad03c",
  null
  
)

export default component.exports